import React from 'react';
import './BankSyncModal.css';
import './BankTransactionDetailModal.css';

function formatGermanDate(isoDate) {
	if (!isoDate) return '';
	const parts = isoDate.split('-');
	if (parts.length !== 3) return isoDate;
	const [year, month, day] = parts;
	return `${day}.${month}.${year}`;
}

// Reiner Anzeige-Dialog fuer eine einzelne Buchung (Zeilenklick in
// BankTransactions.js) - "Neue Ueberweisung" wird nur bei einem Geldausgang
// angeboten (negativer Betrag), weil nur dann Empfaenger/IBAN aus der
// Buchung ueberhaupt als sinnvolle Vorbelegung fuer eine neue Ueberweisung
// taugen (bei einem Geldeingang waere "counterparty" der Absender, nicht der
// gewuenschte Empfaenger einer neuen Ueberweisung).
export default function BankTransactionDetailModal(props) {

	const t = props.transaction;
	const isOutgoing = parseFloat(t.amount) < 0;

	return (
		<div className="banking-sync-overlay">
			<div className="banking-sync-modal banking-transaction-detail-modal">
				<div className="banking-sync-header">
					<span>Buchungsdetails</span>
					<i className="bi bi-x-lg table-icon" onClick={props.onClose}></i>
				</div>
				<div className="banking-sync-body">
					<div className="banking-transaction-detail-row">
						<span className="banking-transaction-detail-label">Datum</span>
						<span>{formatGermanDate(t.bookingdate)}</span>
					</div>
					{t.valuedate && t.valuedate !== t.bookingdate &&
						<div className="banking-transaction-detail-row">
							<span className="banking-transaction-detail-label">Wertstellung</span>
							<span>{formatGermanDate(t.valuedate)}</span>
						</div>
					}
					<div className="banking-transaction-detail-row">
						<span className="banking-transaction-detail-label">Konto</span>
						<span>{t.konto}</span>
					</div>
					<div className="banking-transaction-detail-row">
						<span className="banking-transaction-detail-label">Betrag</span>
						<span className={isOutgoing ? 'amount-negative' : 'amount-positive'}>{t.amount} {t.currency || '€'}</span>
					</div>
					{t.counterpartyname &&
						<div className="banking-transaction-detail-row">
							<span className="banking-transaction-detail-label">{isOutgoing ? 'Empfänger' : 'Auftraggeber'}</span>
							<span>{t.counterpartyname}</span>
						</div>
					}
					{t.counterpartyiban &&
						<div className="banking-transaction-detail-row">
							<span className="banking-transaction-detail-label">IBAN</span>
							<span>{t.counterpartyiban}</span>
						</div>
					}
					{t.purpose &&
						<div className="banking-transaction-detail-row">
							<span className="banking-transaction-detail-label">Verwendungszweck</span>
							<span>{t.purpose}</span>
						</div>
					}
					{t.bankreference &&
						<div className="banking-transaction-detail-row">
							<span className="banking-transaction-detail-label">Bankreferenz</span>
							<span>{t.bankreference}</span>
						</div>
					}
					<div className="banking-sync-all-actions">
						{isOutgoing &&
							<button type="button" className="btn" onClick={props.onNewTransfer}>
								<i className="bi bi-send"></i> Neue Überweisung
							</button>
						}
						<button type="button" className="btn" onClick={props.onClose}>Schließen</button>
					</div>
				</div>
			</div>
		</div>
	)

};
